'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArticleList = function ArticleList(_ref) {
  var articles = _ref.articles;

  var handleClick = function handleClick(id) {
    window.location.href = 'content/' + id;
  };
  var gradientColors = ['#00ff00', // green
  '#00cc00', // dark green
  '#009900', // olive
  '#006600', // forest green
  '#003300'];

  return _react2.default.createElement(
    'ul',
    { style: { display: 'flex', flexDirection: 'column' } },
    articles.map(function (article, index) {
      var gradientColor = gradientColors[index % gradientColors.length];

      return _react2.default.createElement(
        'li',
        {
          key: index,
          onClick: function onClick() {
            console.log("clicked");
            handleClick(article.firstContentId);
          },
          style: {
            background: 'linear-gradient(to bottom, ' + gradientColor + ' 0%, #fff 100%)',
            borderRadius: '8px',
            padding: '16px',
            cursor: 'pointer',
            ':hover': {
              cursor: 'pointer'
            }
          }
        },
        article.name
      );
    })
  );
};

exports.default = ArticleList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/ArticleList.js
// module id = 1526
// module chunks = 0